import { render, staticRenderFns } from "./withstand_value.vue?vue&type=template&id=32f19e48&scoped=true"
import script from "./withstand_value.vue?vue&type=script&lang=js"
export * from "./withstand_value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f19e48",
  null
  
)

export default component.exports